export enum BreakpointEnum {
    MOBILE_SIZE = 980
}